module.exports = __webpack_public_path__ + "Icono_Orden_Solicitada.png";